<template>
  <div class="mb-3" v-bind:class="{ 'center-form-container': !checked }">
    <div class="mt-5" v-if="checked">
      <slot name="billboard"></slot>
      <div class="row my-5">
        <div class="col text-center" v-if="declined">
          <button type="text" class="btn btn-primary" @click="$emit('reset')">Try again</button>
        </div>
        <div class="row col" v-else>
        <div class="col-md-auto">
          <button type="text" class="btn btn-primary btn-block" @click="$emit('nextStep')">Continue</button>
        </div>
        <div class="col d-none d-lg-block">
          <button type="text" class="btn btn-link mr-3" @click="edit">Edit {{stepName}}</button>
        </div>
        </div>
      </div>
    </div>
    <form class="center-form" @submit.prevent="submit" v-else>
      <header>
        <h3><slot name="title"></slot></h3>
      </header>
      <main class="form-group">
        <slot name="form"></slot>
      </main>
      <footer class="row">
        <div class="col-md-auto">
          <button type="submit" class="btn btn-primary btn-block" :disabled="checkLoading || submitting || !validated">
            <icon icon="cog" spin v-if="checkLoading || submitting"/> &nbsp;
            <slot name="submit-text"><span v-if="!checkLoading && !submitting">Check</span><span v-else>Checking...</span></slot>
          </button>
        </div>
          <p class="col-md-auto bgWhite btn-block mt-2" v-show="isHidden" @click="soleTraderHelp" >
           Can't find your name in the list above? <span class="clickable emphasis">Let's talk</span>.
          </p>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'form-step',
  data: function () {
    return {
      submitting: false
    }
  },
  props: {
    checked: Object,
    validated: Boolean,
    declined: Boolean,
    onSubmit: Function,
    stepName: String,
    nextStep: String,
    checkLoading: Boolean,
    isHidden: Boolean
  },
  methods: {
    edit: function () {
      this.$emit('edit')
      // Segment Track Edit Form {{stepName}}
      // window.analytics.track('Edit Form')
    },
    soleTraderHelp () {
      // Segment tracker to trigger sole trade chat
      window.analytics.track('Buy First Policy - Sole Trader Help Asked')
      window.Intercom('show')
    },
    submit: function () {
      this.submitting = true
      Promise.resolve(this.onSubmit()).then(() => {
        this.$emit('check')
        // Important: the state is mutated *outside* of Vuex for reasons unknown.
        // It seems that 'check' is emitted to (Creditor, Debtor, Dates, Amount), and then to Wizard where the actual check is performed.
        // For now, as a workaround, I've passed checkLoading as a prop through both Creditor and Wizard.
        // TODO: state should only be manipulated in the Vuex store, and no events should be emitted that could affect the state. A full refactor is required.
      }, (error) => {
        console.log(error)
        // TODO: display error (e.g. this.error = ...)
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>
